import axiosInstance, { ApiKeys, getApiUrl, logError } from 'src/utils/ApiHelper';

export const fetchCaseHistoryPolling = async () => {
  const url = getApiUrl(ApiKeys.CASE_BROWSING_HISTORY);
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    logError('Error fetching case history');
    return [];
  }
};
